import { genBlock } from "@/utils/bem";
import { Box, chakra, ChakraProps, Flex, Text } from "@chakra-ui/react";
import classNames from "classnames";
import React, { ReactElement, useCallback, useState } from "react";
import style from "./index.module.scss";

interface Props {
  title?: string | ReactElement;
  switchList: Array<ReactElement | string>;
  defaultSelected: number;
  onChange(idx: number): void;
  className?: string;
}

const block = genBlock("c-text-switcher");
function TextSwitcher(props: Props) {
  const { switchList, title, defaultSelected, onChange, className } = props;
  const [selected, setSelected] = useState(defaultSelected);
  const handleChange = useCallback<React.MouseEventHandler<HTMLDivElement>>(
    (e) => {
      const { key } = e.currentTarget.dataset;
      if (key) {
        setSelected(+key);
        onChange(+key);
      }
    },
    [setSelected, onChange],
  );
  return (
    <Box className={classNames(block(), className)}>
      <Flex>
        <Box>
          <Text className={classNames(style.title)}>{title}</Text>
        </Box>
        <Box>
          {switchList.map((s, i) => (
            <Box
              key={i}
              data-key={i}
              className={classNames(style.switch, i === selected && style.selected)}
              onClick={handleChange}
            >
              {s}
            </Box>
          ))}
        </Box>
      </Flex>
    </Box>
  );
}
export default chakra(TextSwitcher);
